module.exports = __webpack_public_path__ + "static/media/contextualBannedWords.5da3905c.txt";